import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../../../../components/action-button';
import { useEntityDelete } from '../../../entities/hooks';
import { fetchOpenInfoDelete } from '../../thunks';
import { IconDeleteCanOutline } from '../../../../common/icons';
import { ROUTE_OPEN_INFO } from '../../../../common/constants';
import { IOpenInfo } from '../../models';

interface OpenInfoActionDeleteProps {
  id: IOpenInfo['id'];
}

export const OpenInfoActionDelete: FC<OpenInfoActionDeleteProps> = ({ id }) => {
  const { t } = useTranslation();
  const { handleDelete } = useEntityDelete({
    thunk: fetchOpenInfoDelete,
    nextPath: ROUTE_OPEN_INFO,
    confirmationText: t('confirmation.delete.text'),
  });

  return (
    <ActionButton
      onClick={() => handleDelete(id)}
      title={t('action.delete')}
      icon={<IconDeleteCanOutline />}
    />
  );
};
